// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { GameLevelItem, GameLevelService, GameLevelStatus } from '../../../../../../../services/game-level.service';

@Component({
    selector: 'app-game-level-index',
    templateUrl: './game-level-index.component.html',
    styleUrls: ['./game-level-index.component.scss'],
    standalone: false
})
export class GameLevelIndexComponent implements OnInit {
  loading = false;
  rows: GameLevelItem[] = [];
  readonly GameLevelStatus = GameLevelStatus;

  constructor(
    private gameLevelSvc: GameLevelService,
    private router: Router,
    private msg: NzMessageService,
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.gameLevelSvc
      .list()
      .then((data) => {
        this.rows = Array.isArray(data) ? data : [];
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  }

  trackById(_: number, row: GameLevelItem): number {
    return row.id;
  }

  rowIndex(i: number): number {
    return i + 1;
  }

  formatCreatedBy(v: number | null | undefined): string {
    if (v === null || v === undefined) {
      return '—';
    }
    return String(v);
  }

  onStatusSwitch(row: GameLevelItem, checked: boolean): void {
    const next = checked ? GameLevelStatus.ACTIVE : GameLevelStatus.INACTIVE;
    const prev = row.status;
    row.status = next;
    this.gameLevelSvc
      .update(row.id, { status: next })
      .then(() => {
        this.msg.success('状态已更新');
      })
      .catch((err: any) => {
        row.status = prev;
        this.msg.error(err?.message || '更新状态失败');
      });
  }

  goEdit(row: GameLevelItem): void {
    this.router.navigate(['/admin/v3/game/levels/edit', row.id]);
  }

  deleteRow(row: GameLevelItem): void {
    this.gameLevelSvc
      .deleteLevel(row.id)
      .then(() => {
        this.msg.success('已删除');
        this.load();
      })
      .catch((err: any) => {
        this.msg.error(err?.message || '删除失败');
      });
  }
}
